import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]

  add() {
    this.listTarget.append(this.templateTarget.content.cloneNode(true))
  }

  remove(event) {
    event.target.closest("[data-repeatable-row]")?.remove()
  }
}
